class CountdownBarComponent extends HTMLElement {
  connectedCallback() {
    const mode = this.dataset.mode || 'fixed';
    let getTarget;

    if (mode === 'daily') {
      // Evergreen: siempre cuenta hasta la próxima medianoche (hora local del visitante)
      getTarget = () => {
        const d = new Date();
        d.setHours(24, 0, 0, 0);
        return d.getTime();
      };
      this.querySelectorAll('[data-days-wrap]').forEach((el) => (el.style.display = 'none'));
    } else {
      const endAttr = this.dataset.end;
      if (!endAttr) return;
      const target = new Date(endAttr).getTime();
      if (Number.isNaN(target)) return;
      getTarget = () => target;
    }

    const all = (sel) => Array.from(this.querySelectorAll(sel));
    const daysEls = all('[data-days]');
    const hoursEls = all('[data-hours]');
    const minutesEls = all('[data-minutes]');
    const secondsEls = all('[data-seconds]');
    const timerEls = all('[data-countdown-timer]');
    const labelEls = all('.countdown-bar__label');
    const hideOnExpiry = this.dataset.hideOnExpiry === 'true';
    const expiredText = this.dataset.expiredText || '';

    const pad = (value) => String(value).padStart(2, '0');
    const setAll = (els, value) =>
      els.forEach((el) => {
        if (el.textContent !== value) el.textContent = value;
      });

    const tick = () => {
      const diff = getTarget() - Date.now();

      if (diff <= 0 && mode !== 'daily') {
        clearInterval(this._interval);
        const section = this.closest('.countdown-bar');

        if (hideOnExpiry) {
          if (section) section.style.display = 'none';
          return;
        }

        timerEls.forEach((el) => (el.style.display = 'none'));
        if (expiredText) labelEls.forEach((el) => (el.textContent = expiredText));
        return;
      }

      const totalSeconds = Math.max(0, Math.floor(diff / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setAll(daysEls, pad(days));
      setAll(hoursEls, pad(hours));
      setAll(minutesEls, pad(minutes));
      setAll(secondsEls, pad(seconds));
    };

    tick();
    this._interval = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }
}

if (!customElements.get('countdown-bar-component')) {
  customElements.define('countdown-bar-component', CountdownBarComponent);
}
